exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-797ba58c]{padding:0 18px}.title-page[data-v-797ba58c]{color:#b8b5b5}.title .divider[data-v-797ba58c]{height:10px;background-color:#EBEEF5;border:none}.midButton[data-v-797ba58c]{width:240px;margin-top:8px}\n", ""]);

// exports
